import { cn } from "@/lib/utils";

type Tone = "neutral" | "info" | "success" | "warning" | "danger";

const TONE_CLASSES: Record<Tone, string> = {
  neutral: "bg-muted text-muted-foreground",
  info: "bg-primary-soft text-primary",
  success: "bg-success/15 text-success",
  warning: "bg-warning/20 text-warning-foreground",
  danger: "bg-destructive/10 text-destructive",
};

export function statusTone(status: string): Tone {
  if (["completed", "approved", "accepted", "assigned", "paid", "resolved", "sent"].includes(status))
    return "success";
  if (["submitted", "matching", "bidding", "scheduled", "in_progress", "under_review", "queued", "open"].includes(status))
    return "info";
  if (["awaiting_customer_approval", "more_info_required", "awaiting_evidence", "pending", "manual_matching", "rework_proposed", "rework_scheduled", "investigating"].includes(status))
    return "warning";
  if (["rejected", "suspended", "cancelled", "failed", "expired", "dead", "critical", "issue_open"].includes(status))
    return "danger";
  return "neutral";
}

export function StatusPill({ status, label }: { status: string; label?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-bold capitalize",
        TONE_CLASSES[statusTone(status)],
      )}
    >
      {label ?? status.replaceAll("_", " ")}
    </span>
  );
}
